module.exports = __webpack_public_path__ + "static/media/VR.8a31a1e1.png";